import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { useSessionEntity } from '@context/EntityContext'

import { PageSection } from '@ui/components/PageSection'

import { isTickmillEUType, isTickmillUKType } from '@utils/companyName.utils'

import styles from './W8BeneficialPage.module.scss'

export const W8BeneficialEPage = () => {
  const { t } = useTranslation()
  const entity = useSessionEntity()

  const getEntityEmail = (entity: number): string => {
    if (isTickmillUKType(entity)) {
      return 'backoffice@tickmill.co.uk'
    }
    if (isTickmillEUType(entity)) {
      return 'backoffice@tickmill.eu'
    }
    return 'backoffice@tickmill.com'
  }

  return (
    <>
      <PageSection title={t('Profile.W-8BEN-e')} />

      <div className={classNames(styles.container, 'box mt-4')}>
        <div className={classNames(styles.info, 'p-5')}>
          {t('Profile.Corporate clients are required to complete the W-8BEN-E form')}{' '}
          <a
            href='https://www.irs.gov/pub/irs-pdf/fw8bene.pdf'
            className='is-link'
            target='_blank'
            rel='noreferrer'
          >
            {t('here')}
          </a>{' '}
          {`${t('Profile.Document management in Client Area')}`}{' '}
          <a
            title={getEntityEmail(entity)}
            href={`mailto:${getEntityEmail(entity)}`}
            className='is-link'
          >
            {getEntityEmail(entity)}
          </a>
        </div>
      </div>
    </>
  )
}
